import { POST_ACTION_SHARE, POST_ACTIONS, type PostAction } from '../constants/post-actions';
import { type NormalizedPost } from '../types';

export const getPostActions = ({
  actions = POST_ACTIONS,
  post,
  canSee,
  enableShare = true,
}: {
  actions?: PostAction[] | readonly PostAction[];
  post: NormalizedPost;
  canSee: (action: PostAction, type: 'post', post: NormalizedPost) => boolean;
  enableShare?: boolean;
}): PostAction[] => {
  const hiddenActions: PostAction[] = [];

  if (!enableShare) {
    hiddenActions.push(POST_ACTION_SHARE);
  }

  const visibleActions = actions.filter(
    (action) => canSee(action, 'post', post) && !hiddenActions.includes(action),
  );

  return visibleActions;
};
